// extracted by mini-css-extract-plugin
export default {"container":"CreatePasswordForm_container__aUl3-","title":"CreatePasswordForm_title__AyEBQ","form":"CreatePasswordForm_form__rautY","submit":"CreatePasswordForm_submit__MRvhg"};